/*
 * Brand
*/
export const GET_BRANDS = "GET_BRAND"
export const GET_BRANDS_SUCCESS = "GET_BRAND_SUCCESS"
export const GET_BRANDS_ERROR = "GET_BRAND_ERROR"

/*
 * Brand Create
*/
export const CREATE_BRAND = "CREATE_BRAND"
export const CREATE_BRAND_SUCCESS = "CREATE_BRAND_SUCCESS"
export const CREATE_BRAND_ERROR = "CREATE_BRAND_ERROR"

/*
 * Update Brand
 */

export const UPDATE_BRAND = "UPDATE_BRAND"
export const UPDATE_BRAND_SUCCESS = "UPDATE_BRAND_SUCCESS"
export const UPDATE_BRAND_ERROR = "UPDATE_BRAND_ERROR"

export const UPDATE_CURRENT_BRAND = "UPDATE_CURRENT_BRAND"

export const RESET_BRAND_ERROR = "RESET_BRAND_ERROR"

/*
 * Update Brand Transactions
 */
export const GET_BRANDS_TRANSACTIONS = "GET_BRANDS_TRANSACTIONS"
export const GET_BRANDS_TRANSACTIONS_SUCCESS = "GET_BRANDS_TRANSACTIONS_SUCCESS"
export const GET_BRANDS_TRANSACTIONS_ERROR = "GET_BRANDS_TRANSACTIONS_ERROR"
